





















































import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
  props: {
    itemMenu: {
      type: Number,
      default: 1
    },
    items: {
      type: Array,
      default: () => [
        {
          text: "Termíny",
          icon: "mdi-clock",
          link: "/admin/schedule"
        },
        {
          text: "Kalendár",
          icon: "mdi-calendar",
          link: "/admin/calendar"
        }
      ]
    },
    drawer: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: true
    },
    barberMenu: Number
  }
})
export default class AdminMenu extends Vue {
  itemMenu!: number;

  private getBarberImage() {
    return this.$store.getters.barberPhoto(this.$store.getters.actualBarber);
  }
}
